import { RequestParams, fetchData } from 'views/utils/fetchData';

// sign_gate(パスキー認証)のstate/code_verifier検証用 sessionStrageキー
export const SignGateStateKey = 'sign_gate_state';
export const SignGateCodeVerifierKey = 'sign_gate_code_verifier';
export const SignGateAccountKey = 'sign_gate_account';

export type SignGateRequestBody = {
  action: string;
  auth_flow: string;
  state: string;
  code_challenge: string;
  client_disp_name: string;
  user_disp_name: string;
  redirect_url: string;
  response_url_on_fail: string;
  credential_id?: string;
};

export type AuthorizedRequestParams = RequestParams;

export type SignGateSuccess = {
  status_code: number;
  redirect_url: string;
};

export type SignGateError = {
  status_code: number;
  error_type: string;
  error_message?: string;
  error_webauthn?: string;
};

export type SignGateResponse = SignGateSuccess | SignGateError;

export const isSignGateSuccess = (response: SignGateResponse): response is SignGateSuccess => {
  return 'redirect_url' in response && response.status_code === 302;
};

export const generateRandomNumericString = (length: number): string => {
  const digits: string[] = [];
  const randomValues = new Uint8Array(length);

  while (digits.length < length) {
    crypto.getRandomValues(randomValues);
    randomValues.forEach((value) => {
      if (digits.length < length && value < 250) {
        digits.push(String(value % 10));
      }
    });
  }

  return digits.join('');
};

export const base64UrlEncode = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const generatePkceCodeVerifier = (): string => {
  const randomValues = new Uint8Array(32);
  crypto.getRandomValues(randomValues);

  return base64UrlEncode(randomValues.buffer);
};

export const generatePkceCodeChallenge = async (codeVerifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  const bytes = new Uint8Array(digest);

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const fetchDataWithAuthorization = <T>(
  url: string,
  token: string,
  params: AuthorizedRequestParams = { method: 'POST' },
): Promise<T> => {
  return fetchData<T>(url, {
    ...params,
    headers: {
      ...(params.headers ?? {}),
      Authorization: `Bearer ${token}`,
    },
  });
};
